

export type RouteKeys = 'wms-job' | 'task' | 'fulfillment' | 'sales_orders' | 'outbound-shipment' | 'cycle_count' | 'work-order' | 'purchase-order' | 'asn' | 'stock_transfer' | 'inventory_adjustment' | 'kit_order' | 'warehouse_transfer';


export function getRouteUrl(key: RouteKeys): string | undefined {
  const urls: Record<RouteKeys, string> = {
    'wms-job': '/operations/jobs/detail',
    'task': '/operations/tasks/detail',
    'fulfillment': '/fulfillment/fulfillment-requests/detail',
    'sales_orders': '/outbound/sales-orders/detail',
    // The module is mounted at 'outbound/outbound-truck' in app-routing.module.ts,
    // not 'outbound/outbound-shipment'. The old value here matched no registered
    // route and 404'd. Matches shared/history/route.map.ts, which was already correct.
    'outbound-shipment': '/outbound/outbound-truck/detail',
    'cycle_count': '/inventory/cycle-counts/detail',
    'work-order': '/kitting/kit-orders/detail',
    'purchase-order': '/inbound/purchase-order/detail',
    'asn': '/inbound/asn/detail',
    'stock_transfer': '/inventory/stock-transfer/detail',
    'inventory_adjustment': '/inventory/inventory-adjustments/detail',
    'kit_order': '/kitting/kit-orders/detail',
    'warehouse_transfer': '/inventory/warehouse-transfer/detail'
  };

  return urls[key];
}
